/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlPaymentStatus = {
    Paid: 'PAID',
    Unpaid: 'UNPAID'
} as const;
export type ControlPaymentStatus = typeof ControlPaymentStatus[keyof typeof ControlPaymentStatus];


export function ControlPaymentStatusFromJSON(json: any): ControlPaymentStatus {
    return ControlPaymentStatusFromJSONTyped(json, false);
}

export function ControlPaymentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaymentStatus {
    return json as ControlPaymentStatus;
}

export function ControlPaymentStatusToJSON(value?: ControlPaymentStatus | null): any {
    return value as any;
}

